import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import FixFlowStep from './FixFlowStep'

class WorkHoursStep extends FixFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.fix.steps.work_hours.title'),
      component,
      i18n.t('contract_versions.flows.fix.steps.work_hours.description')
    )
  }
}

export default WorkHoursStep
